import { cn } from '@/lib/utils';
import SellytLogo from '@/assets/svg/sellyt-logo.svg?react';
import { Heading, Paragraph } from '@/components/atoms';
import { cva, type VariantProps } from 'class-variance-authority';

const subscriptionVariants = cva(
  'w-full max-w-lg rounded-xl relative drop-shadow-lg',
  {
    variants: {
      variant: {
        freemium: 'bg-gradient-to-br from-green-950 to-green-800',
        standard: 'bg-gradient-to-br from-blue-800 to-blue-600',
        premium: 'bg-gradient-to-br from-gray-900 to-gray-600',
        scale: 'bg-gradient-to-br from-emerald-950 to-teal-700',
      },
    },
    defaultVariants: {
      variant: 'standard',
    },
  }
);

interface SubscriptionCardProps
  extends VariantProps<typeof subscriptionVariants> {
  planName: string;
  description: string;
  price: string;
  period?: string;
  badge?: string;
  className?: string;
}

function SubscriptionCard({
  planName,
  description,
  price,
  period = 'Year',
  badge,
  className,
  variant = 'freemium',
}: SubscriptionCardProps) {
  return (
    <div className={cn(subscriptionVariants({ variant }), className)}>
      <div
        className="absolute inset-0  bg-contain bg-bottom bg-no-repeat"
        style={{ backgroundImage: 'url(/images/semi-spirals.png)' }}
      />

      <div className="relative p-6 lg:p-8 flex flex-col gap-8 md:gap-12">
        <div className="flex flex-col gap-2">
          <div className="flex flex-col">
            <SellytLogo className="w-16 h-8 self-end" />
            <Heading
              size="3xl"
              className="font-bold text-primary flex items-baseline gap-3 flex-wrap"
            >
              {planName}
              {badge && (
                <span className="text-white text-xs font-normal">
                  ({badge})
                </span>
              )}
            </Heading>
          </div>
          <Paragraph size="sm" className="text-white">
            {description}
          </Paragraph>
        </div>

        {/* Price */}
        <div className="flex items-baseline gap-2">
          <Paragraph size="lg" className="text-white font-semibold lg:text-3xl">
            {price}
          </Paragraph>
          <Paragraph size="lg" className="text-white text-lg">
            / {period}
          </Paragraph>
        </div>
      </div>
    </div>
  );
}

export { SubscriptionCard };
